<template>
  <div class="pageInner">
    <!-- <h4 ref="title">Parcelas Pendentes</h4> -->
    <header>
      <div></div>
      <div></div>
    </header>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="scss scoped">
  
</style>